<template>
  <div class="header">
    <div class="headercon">
      <img src="@/assets/logo.png" />
      <div class="topmenu">
        <el-menu :default-active="activePath" mode="horizontal" :router="true" active-text-color="#f00">
          <template v-for="item in menulist">
            <template v-if="item.children.length == 0">
              <el-menu-item :key="item.id" :index="'/' + item.path" @click="SavaActive('/' + item.path)"
                ><span>{{ item.authName }}</span></el-menu-item
              >
            </template>
            <template v-else>
              <el-submenu :index="'/' + item.path" :key="item.id" @click="SavaActive('/' + item.path)">
                <template slot="title">
                  <span>{{ item.authName }}</span>
                </template>

                <el-menu-item
                  :index="'/' + subitem.path"
                  v-for="subitem in item.children"
                  :key="subitem.id"
                  @click="SavaActive('/' + subitem.path)"
                >
                  <template slot="title">
                    <span>{{ subitem.authName }}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </template>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/util/bus'
export default {
  data() {
    return {
      activePath: '',
      menulist: [
        {
          id: 1,
          authName: '首页',
          path: 'home',
          children: []
        },
        {
          id: 2,
          authName: '产品与方案',
          path: 'hospital',
          children: [
            {
              id: 21,
              authName: '医院绩效管理解决方案',
              path: 'hospital/case05'
            },

            {
              id: 22,
              authName: '医院精细化数据分析平台',
              path: 'hospital/case06'
            },
            {
              id: 23,
              authName: '医院全成本核算解决方案',
              path: 'hospital/case07'
            },
            {
              id: 24,
              authName: '医院全面预算解决方案',
              path: 'hospital/case08'
            }
          ]
        },
        {
          id: 3,
          authName: '咨询服务',
          path: 'zixun',
          children: []
        },
        {
          id: 4,
          authName: '成功案例',
          path: 'success',
          children: []
        },
        {
          id: 5,
          authName: '行业资讯',
          path: 'news',
          children: []
        },
        {
          id: 6,
          authName: '关于我们',
          path: 'about',
          children: []
        }
      ]
    }
  },
  created() {
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath)
    // },
    SavaActive(activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
      console.log('this.activePath', this.activePath)
      bus.$emit('setActivePath', activePath)
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  .headercon {
    width: 1200px;
    padding: 20px 0;
    margin: 0 auto;
    img {
      float: left;
    }
    .topmenu {
      width: 70%;
      float: right;
      .el-menu {
        border: none;
        .el-menu-item {
          width: 135px;
          text-align: center;
          font-size: 18px;
        }
      }
      ::v-deep .el-menu-item {
        font-size: 18px !important;
      }
      ::v-deep.el-submenu__title {
        font-size: 18px;
      }
    }
  }
}
</style>
<style>
.el-menu-item {
  font-size: 18px !important;
}
</style>
